import superset from "./superset.js";

export default function subset(values, other) {
  return superset(other, values);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/subset.js
// module id = 432
// module chunks = 0